import React from 'react'
import {PIMBaseLabel} from './Bases/PIMBaseLabel'
import {Color} from '../../Styles'

export type PIMWarningMessagesProps = {
  messages: string[]
}

export const PIMWarningMessages: React.VFC<PIMWarningMessagesProps> = (props) => {
  return (
    <>
      {props.messages.map((message, idx) => (
        <PIMBaseLabel
          key={`warning-message-${idx}`}
          fontRemSize={1.3}
          color={Color.Red500}
          lineHeight={1.5}
        >
          {message}
        </PIMBaseLabel>
      ))}
    </>
  )
}
